import React from 'react';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Chip, Divider, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';

// assets
import { IconUserPlus } from '@tabler/icons';

// style constant
const useStyles = makeStyles((theme) => ({
    navContainer: {
        width: '100%',
        maxWidth: '330px',
        paddingTop: 0,
        paddingBottom: 0,
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '300px'
        }
    },
    listAction: {
        top: '22px'
    },
    actionColor: {
        color: theme.palette.grey[500]
    },
    listItem: {
        padding: 0
    },
    listDivider: {
        marginTop: 0,
        marginBottom: 0
    },
    listChipError: {
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
        height: '24px',
        padding: '0 6px',
        marginRight: '5px'
    },
    listAvatarPrimary: {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
        border: theme.palette.mode === 'dark' ? '1px solid' : 'none',
        borderColor: theme.palette.primary.main
    },
    listContainer: {
        paddingLeft: '56px'
    },
    paddingBottom: {
        paddingBottom: '16px'
    },
    itemAction: {
        cursor: 'pointer',
        padding: '16px',
        '&:hover': {
            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
        }
    },
    empty: {
        padding: '32px 16px',
        textAlign: 'center',
        color: theme.palette.grey[500]
    }
}));

function timeAgo(dateStr) {
    const diffMs = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins} min ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs} hr ago`;
    return `${Math.floor(hrs / 24)} day ago`;
}

//-----------------------|| NOTIFICATION LIST ITEM ||-----------------------//

const NotificationList = ({ notifications = [], onItemClick }) => {
    const classes = useStyles();

    if (notifications.length === 0) {
        return (
            <div className={classes.empty}>
                <Typography variant="body2">No notifications yet</Typography>
            </div>
        );
    }

    return (
        <List className={classes.navContainer}>
            {notifications.map((n, idx) => (
                <React.Fragment key={n._id}>
                    <div className={classes.itemAction} onClick={() => onItemClick && onItemClick(n)}>
                        <ListItem alignItems="center" className={classes.listItem}>
                            <ListItemAvatar>
                                <Avatar className={classes.listAvatarPrimary}>
                                    <IconUserPlus stroke={1.5} size="1.3rem" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography variant="subtitle1">{n.title}</Typography>} />
                            <ListItemSecondaryAction className={classes.listAction}>
                                <Grid container justifyContent="flex-end">
                                    <Grid item xs={12}>
                                        <Typography variant="caption" display="block" gutterBottom className={classes.actionColor}>
                                            {timeAgo(n.createdAt)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Grid container direction="column" className={classes.listContainer}>
                            <Grid item xs={12} className={classes.paddingBottom}>
                                <Typography variant="subtitle2">{n.body}</Typography>
                            </Grid>
                            {!n.read && (
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item>
                                            <Chip label="Unread" className={classes.listChipError} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </div>
                    {idx < notifications.length - 1 && <Divider className={classes.listDivider} />}
                </React.Fragment>
            ))}
        </List>
    );
};

export default NotificationList;
